import emptyState from "../store/emptyState";
import { CasinoActionConstants } from "../action-constants";
import globalReducerHelper from "./globalReducerHelper";

const casino = (state = emptyState.casino, action) => {
  const { type, payload } = action;

  switch (type) {
    case CasinoActionConstants.SET_IS_SIC:
      return { ...state, isSIC: action.payload };
    case CasinoActionConstants.SET_GAMBLING_SESSION:
      return { ...state, gamblingSession: action.payload };

    default:
      return globalReducerHelper(
        state,
        type,
        payload && payload.casino,
        emptyState.casino
      );
  }
};

export default casino;
